import EmailInput from "Source/components/project/Common/Form/EmailInput/EmailInput";
import EmailInputContainer from "Source/components/project/Common/Form/EmailInput/EmailInputContainer";
import React from "react";
import { copyToClipboard } from "Source/util/navigator";
import { checkIfAdmin } from "Source/lib/authorization/authorization";
import { FALLBACK_EMAIL } from "Source/components/project/Config/Config";
import { connect } from "react-redux";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
    };
})

class WorkstreamEmail extends React.Component {
    constructor(props) {
        super(props);
    }

    handleCopy = () => {
        const { email } = this.props;

        copyToClipboard(email);
    }

    render() {
        const { loggedUser, email, isEdit, accountNameSuffix, fieldEmailProps }= this.props;
        const isAdmin = checkIfAdmin(loggedUser.data);
        const currentEmail = email
            ? email
            : FALLBACK_EMAIL;

        if (!isEdit || isAdmin) {
            return <EmailInputContainer
                    label="Workstream Email"
                    errorMessage={fieldEmailProps.errorMessage}
                    valid={fieldEmailProps.valid}
                    suffix={accountNameSuffix}
                >
                <EmailInput
                    name="email"
                    label="Workstream Email"
                    placeholder="Workstream Email"
                    {...fieldEmailProps}
                />
            </EmailInputContainer>
        }

        return (
            <div class="formSection">
                <div class="formContainer emailInputOnEdit">
                    <label>Workstream Email <sup>*</sup></label>
                    <p class="mb0 mr10">{ currentEmail  }</p>
                    {currentEmail !== FALLBACK_EMAIL && 
                        <a onClick={this.handleCopy}><i class="material-icons">content_copy</i></a> 
                    }
                </div>
            </div>
        );
    }
}

export default WorkstreamEmail;
